module.exports = __webpack_public_path__ + "static/img/(Banner-4月9日）第一届细菌感染峰会－微网站-2.9-32.d9e65058.jpg";